const deserializePhone = (value) => {
	let tel = {};

	switch (value.length) {
		case 4:
		case 5:
		case 6:
		case 7: // ####### -> ###-####
			tel.number = value;
			break;

		case 8:
		case 9:
		case 10: // PPP####### -> (PPP) ###-####
			tel.country = 1;
			tel.city = value.slice(0, 3);
			tel.number = value.slice(3);
			break;

		case 11: // +CPPP####### -> C (PPP) ###-####
			tel.country = value[0];
			tel.city = value.slice(1, 4);
			tel.number = value.slice(4);
			break;

		case 12: // +CCCPP####### -> CCC (PP) ###-####
			tel.country = value.slice(0, 3);
			tel.city = value.slice(3, 5);
			tel.number = value.slice(5);
			break;

		default:
			tel.number = value;
	}

	return tel;
};

export default function (tel) {
	if (!tel) { return ''; }

	let value = tel.toString().trim().replace(/^\+/, '');

	if (value.match(/[^0-9]/)) {
		return tel;
	}

	let phoneNumber = deserializePhone(value);

	if (phoneNumber.country === 1) {
		phoneNumber.country = '';
	}

	if (phoneNumber.number.length > 6 && phoneNumber.number.length < 13) {
		phoneNumber.number = phoneNumber.number.slice(0, 3) + '-' + phoneNumber.number.slice(3);
	}

	if (!phoneNumber.city) {
		return phoneNumber.number.trim();
	}

	return (phoneNumber.country + ' (' + phoneNumber.city + ') ' + phoneNumber.number).trim();
}
